// extracted by css-extract-rspack-plugin
export default {"highlightOnHover":"Qa0Gd"};